const locale = require('./reasonFormModal.i18n.json');

/*@ngInject*/
const ReasonFormModalController = function ($rootScope, $scope, cancelActionCallback, confirmActionCallback, coreConstant, formViewerModel, loadingBarHandler, localizationRoot, logAction, submission, reasonFormId) {

    $scope.i18n = locale[localizationRoot];
    $scope.title = $scope.i18n.title;
    $scope.confirmButton = $scope.i18n.confirmButton;
    $scope.cancelButton = $scope.i18n.cancelButton;

    $scope.formId = reasonFormId;
    $scope.submissionId = submission.id;
    $scope.confirmActionCallback = confirmActionCallback;
    $scope.cancelActionCallback = cancelActionCallback;
    $scope.logAction = logAction;

    $scope.effectiveDate = submission.effectiveDate;
    $scope.currencyCode = submission.currencyCode;

    $scope.canEnableConfirmButton = function () {
        const formStructure = formViewerModel.getFormStructure($scope.formId);
        if (formStructure && formStructure.formModel && formStructure.formModel.totalRequiredFieldCount === 0) {
            return true;
        }

        return false;
    };

    $scope.onConfirm = function () {
        loadingBarHandler.showLoadingBar($scope.i18n.loadingBar);
        startPerformanceLog($scope.logAction, $scope.submissionId);
        $scope.confirmActionCallback($scope.submissionId).then(() => {
            stopPerformanceLog($scope.logAction, coreConstant.uiPeformanceLogger.SUCCESS);
            loadingBarHandler.hideLoadingBar();
            $scope.$close();
        }, () => {
            stopPerformanceLog($scope.logAction, coreConstant.uiPeformanceLogger.FAIL);
        });
    };

    $scope.onCancel = function () {
        $scope.cancelActionCallback($scope.submissionId).then(() => {
            $scope.$dismiss();
        })
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, () => {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    function startPerformanceLog(logAction, submissionId) {
        if (logAction) {
            const message = submissionId.toString();
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction, message);
        }
    }

    function stopPerformanceLog(logAction, status) {
        if (logAction) {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, status);
        }
    }

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('reasonFormModalController', ReasonFormModalController);
